import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  lessPaddingMobile: {
    '& .MuiPaper-root.MuiPaper-elevation24.MuiDialog-paper': {
      [useBreakpoints(theme).lessThan.lg]: {
        margin: '0',
        width: 'calc(100% - 32px)',
        maxWidth: 'initial',
      },
    },
  },
  removePaddingMobile: {
    '& .MuiPaper-root.MuiPaper-elevation24.MuiDialog-paper': {
      [useBreakpoints(theme).lessThan.lg]: {
        margin: '0',
        width: '100%',
        minHeight: '100%',
        maxWidth: '100%',
      },
    },
  },
  modalBtn: {
    [useBreakpoints(theme).lessThan.lg]: {
      padding: '18px 42px',
      lineHeight: 1.12,
    },
  },
  modalparagraph: {
    fontSize: ' 14px',
    height: '50px',

    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    padding: ' 0 0 0 60px',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#f74872',
  },
}))
